module.exports = __webpack_public_path__ + "public/img/news.a3db284b.png";